import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators'; // Usa gli operatori corretti di RxJS
import { environment } from './../../../../environments/environment';
import { CostItemGeneric } from './../../_models/financials/costItemGeneric';

@Injectable()
export class CostItemGenericsService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  getList(): Observable<CostItemGeneric[]> {
    return this.http.get<CostItemGeneric[]>(
      `${this.apiBaseUrl}api/private/v1/financial/costItemGenerics`
    );
  }

  get(id: number): Observable<CostItemGeneric> {
    return this.http.get<CostItemGeneric>(
      `${this.apiBaseUrl}api/private/v1/financial/costItemGenerics/${id}`
    );
  }

  save(costItemGenericItem: CostItemGeneric): Observable<CostItemGeneric> {
    const costItemGeneric = { ...costItemGenericItem };
    // Rimuovi campi non necessari
    delete costItemGeneric.lastUpdated;
    delete costItemGeneric.dateCreated;

    // Aggiungi il companyId se presente
    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    costItemGeneric.companyId = companySelected ? companySelected.id : null;

    // Se l'utente è presente, prendi solo l'ID
    if (costItemGeneric.user && costItemGeneric.user.id) {
      costItemGeneric.user = { id: costItemGeneric.user.id };
    }

    // Se c'è un ID, fai una PUT, altrimenti fai una POST
    if (costItemGeneric.id) {
      return this.http.put<CostItemGeneric>(
        `${this.apiBaseUrl}api/private/v1/financial/costItemGenerics/${costItemGeneric.id}`,
        costItemGeneric
      );
    } else {
      return this.http.post<CostItemGeneric>(
        `${this.apiBaseUrl}api/private/v1/financial/costItemGenerics/`,
        costItemGeneric
      );
    }
  }

  delete(costItemGeneric: CostItemGeneric): Observable<CostItemGeneric> {
    return this.http
      .delete<void>(
        `${this.apiBaseUrl}api/private/v1/financial/costItemGenerics/${costItemGeneric.id}`
      )
      .pipe(
        map(() => {
          return { id: costItemGeneric.id } as CostItemGeneric;
        })
      );
  }
}
